import React, { useEffect, useState } from 'react';
import { secondsToTime } from '../../../utils/time';
import { SubTitle, Screenshots, STable, ScreenInner } from './styled';
import { getScreenshotsByTaskId } from '../../../firebase/api/tracking';
import preloaderImg from '../../../svg/dot-preloader-dark.svg';
import Screenshot from './Screenshot';
import styled from 'styled-components';

const SImg = styled.img`
  width: 30px;
  margin: 0 auto;
`;

export const baseScreenshotsCount = 4;

const TaskStatistic: React.FC<{
  taskId: string;
  taskName: string;
  userId: string;
  day: number;
  seconds: number;
  screenshotsDate: string;
}> = (props) => {
  const [screenshots, setScreenshots] = useState<{ id: string; screen: string }[]>([]);
  const [loadingScreens, setLoadingScreens] = useState<boolean>(false);
  const [hasLoadMoreBtn, setHasLoadMoreBtn] = useState<boolean>(true);
  const screenshotsIds = screenshots.map((el) => el.id);

  const loadScreenshots = async (isLimited: number) => {
    try {
      setLoadingScreens(true);
      const res = await getScreenshotsByTaskId(props.taskId, props.userId, props.day, isLimited);
      setLoadingScreens(false);
      const filtered = res?.filter((el) => !screenshotsIds.includes(el.id));
      if (isLimited && !filtered?.length) setHasLoadMoreBtn(false);
      !!filtered && !!filtered.length && setScreenshots(screenshots.concat(filtered));
    } catch (e) {
      console.log(e);
      setLoadingScreens(false);
    }
  };

  useEffect(() => {
    loadScreenshots(Date.now());
  }, [props.userId]);

  return (
    <div>
      <STable>
        <thead>
          <tr>
            <th>Задача</th>
            <th>Время</th>
            <th>Скриншоты</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-label="Задача">{props.taskName}</td>
            <td data-label="Время">{secondsToTime(props.seconds)}</td>
            <td data-label="Скриншоты">
              <Screenshots>
                {screenshots.length ? (
                  <ScreenInner>
                    {screenshots
                      .sort((a, b) => Number(a.id) - Number(b.id))
                      .reverse()
                      .map((screen, index, self) => (
                        <Screenshot key={index} allScreens={self} />
                      ))}
                    {hasLoadMoreBtn && (
                      <span
                        onClick={() =>
                          !!screenshots.length &&
                          loadScreenshots(Number(screenshots[screenshots.length - 1].id))
                        }
                      >
                        {loadingScreens ? 'загрузка...' : 'еще'}
                      </span>
                    )}
                  </ScreenInner>
                ) : loadingScreens ? (
                  <SImg src={preloaderImg} alt="loading..." />
                ) : (
                  <span>Нету скриншотов</span>
                )}
              </Screenshots>
            </td>
          </tr>
        </tbody>
      </STable>
      <SubTitle></SubTitle>
    </div>
  );
};

export default TaskStatistic;
